import Vue from "vue";
import MTextFieldVue from "./m-text-field";
import MDatePickerVue from "./m-date-picker";

Vue.component("m-text-field", MTextFieldVue);
Vue.component("m-date-picker", MDatePickerVue);
